// extracted by mini-css-extract-plugin
export default {"textSection":"TextSection__textSection","h1":"TextSection__h1","h2":"TextSection__h2","h3":"TextSection__h3","blockAlign":"TextSection__blockAlign"};